<template>
  <div class="">
    
    <!-- 查询表单 -->
    <div>
      <el-form ref="ctiyProgramForm" :model="ctiyProgramForm" label-width="80px">
        <el-row :gutter="20">
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-form-item label="创建时间">
              <el-date-picker clearable
                v-model="ctiyProgramForm.createTime"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptions">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-form-item label="城市经理">
             <el-input clearable v-model="ctiyProgramForm.userLike"  placeholder="请输入城市经理姓名或电话"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-button type="primary" @click="getCityList">查询</el-button>
            <el-button type="primary" @click="addCtiy">添加</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div style="margin-top: 20px;">
            <!-- 表格 -->
       <el-table
        :data="tableData"
        border
        style="width: 100%">
          <el-table-column
            prop="code"
            label="城市经理ID">
          </el-table-column>
          <el-table-column
            prop="realName"
            label="城市经理姓名">
          </el-table-column>
          <el-table-column
            prop="phone"
            label="电话">
          </el-table-column>
          <el-table-column
            prop="password"
            label="密码">
          </el-table-column>
          <el-table-column
            prop="createTime"
            label="创建时间">
          </el-table-column>
          <el-table-column
            prop="status"
            label="账号状态">
            <template slot-scope="scope">
              <span v-if="scope.row.status === 1">已启用</span>
              <span v-else>已禁用</span>
            </template>
          </el-table-column>
          <el-table-column
            label="操作">
              <template slot-scope="scope">
                <el-button @click="editorCity(scope.row)" type="text" size="small">编辑</el-button>
                <el-button @click="openCity(scope.row.id)" type="text" size="small" v-if="scope.row.status === 0">开启</el-button>
                <el-button @click="closeCity(scope.row.id)" type="text" size="small" style="color: red;" v-else>关闭</el-button>
                <el-button @click="deleteUser(scope.row.id)" type="text" size="small" style="color: gray;">删除</el-button>
              </template>
          </el-table-column>
      </el-table>
      

      <!-- 分页 -->
      <el-pagination style="margin-top: 20px;"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 40, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="tableTotal">
      </el-pagination>
    </div>

    <!-- 修改或新建城市经理对话框 -->
    <el-dialog :title="dlgType === 'change' ? '编辑账号' : '新建账号'" :visible.sync="isDlg" width="700px">
      <div style="margin: 20px;">
        <div>
          <el-form ref="editCityForm" :rules="editorFormRules" :model="editCityForm" label-width="100px">
            <el-form-item label="城市经理ID" v-if="dlgType === 'change'" >
              <el-input clearable v-model="editCityForm.code" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="姓名" prop="realName">
              <el-input clearable v-model="editCityForm.realName"></el-input>
            </el-form-item>
            <el-form-item label="电话" prop="phone">
              <el-input clearable v-model="editCityForm.phone"></el-input>
            </el-form-item>
            <el-form-item label="密码" prop="password">
              <el-input clearable v-model="editCityForm.password"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div style="text-align: center;">
          <el-button type="primary" style="margin: 30px 20px;" @click="submitEditor">确定</el-button>
          <el-button style="margin: 10px 20px;" @click="closeEditorCityDlg">暂不</el-button>
        </div>
      </div>
    </el-dialog>

  </div>
</template>

<script>
export default {
  components:{},
  props:{},
  data(){
    return {
      // 查询数据
      ctiyProgramForm: {
        createTime: [],
        userLike: ''
      },

      // 日期选择插件配置
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },

      // 表格数据
      tableTotal: 0,
      tableData: [],
      pageSize: 10,
      currentPage: 1,


      // 新建编辑对话框数据

      isDlg: false,
      editCityForm: {
        id: null,
        type: 3,
        roleId: 4,
        code: null,
        realName: null,
        phone: null,
        password: null,
      },

      editorFormRules: {
        realName: [
          { required: true, message: '请输入城市经理姓名', trigger: 'change' },
        ],
        phone: [
          { required: true, message: '请输入电话', trigger: 'change' },
        ],
        password: [
          { required: true, message: '请输入账号密码', trigger: 'change' },
        ],
      },

      dlgType: 'change'
      
    }
  },
  watch:{},
  computed:{},
  methods:{
        //删除用户
    deleteUser(id){
      let self = this
      self.$confirm('是否删除').then(() => {
         self.$api.deleteUser({id:id}).then(res=>{
           if(res.code === 200) {
            this.$message({
              message: '删除成功',
              type: 'success'
            });
             this.getCityList()
          }
      })
      })
    },
      // 分页函数
    handleSizeChange(val) {
      this.pageSize = val;
      // 每次调整pagesize后，跳回第一页，保证有数据及请求不会报错
      this.handleCurrentChange(1)
    },
    handleCurrentChange(val) {
      this.currentPage = val

      // 重新请求订单数据
      this.getCityList()
    }, 

    // 获取订单数据
    getCityList() {
      let self  = this;
      self.$api.getUserList({
        type: 3,
        roleId: 4,
        page: self.currentPage,
        size: self.pageSize,
        userLike: self.ctiyProgramForm.userLike || null,
        createTimeStart: self.ctiyProgramForm.createTime instanceof Array && self.ctiyProgramForm.createTime.length>1 ? self.ctiyProgramForm.createTime[0] + ' 00:00:00' : null,
        createTimeEnd: self.ctiyProgramForm.createTime instanceof Array && self.ctiyProgramForm.createTime.length>1 ? self.ctiyProgramForm.createTime[1] + ' 23:59:59' : null,
      }).then(res => {

        self.tableData = res.data.records || []
        self.tableTotal = res.data.total
      })
    },

    // 添加城市经理
    addCtiy() {
      this.dlgType = 'new'
      this.editCityForm = {
        id: null,
        type: 3,
        roleId: 4,
        code: null,
        realName: null,
        phone: null,
        password: null,
      },
       this.$nextTick(()=>{
          this.$refs['editCityForm'].clearValidate()
      })
      this.isDlg = true
    },

    // 修改城市经理
    editorCity(row) { 
      console.log(row);
      this.dlgType = 'change'

      for(let i in this.editCityForm) {

        if(i !== 'type' ) {
          this.editCityForm[i] = row[i]
        }
      }
      this.isDlg = true
    },

    // 关闭编辑对话框
    closeEditorCityDlg() {
      this.isDlg = false
    },

    // 提交编辑（新建或者修改）
    submitEditor() {
      let self = this;

      this.$refs['editCityForm'].validate((valid) => {
        if (valid) {
          if(self.dlgType === 'change') {
            console.log('aa');
            self.$api.changeUser(self.editCityForm).then(res => {
              if(res.code === 200) {
                this.$message({
                  message: '修改成功',
                  type: 'success'
                });
                this.getCityList()
                this.closeEditorCityDlg()
              }
            })
          } else {
            self.$api.addUser(self.editCityForm).then(res => {
              if(res.code === 200) {
                this.$message({
                  message: '添加成功',
                  type: 'success'
                });
                this.getCityList()
                this.closeEditorCityDlg()
              }
            })
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
      
    },


    // 关闭城市经理
    closeCity(id) {
      this.$api.closeUser(id, {
        userId: id
      }).then(res => {
        if(res.code === 200) {
          this.$message({
            message: '关闭成功',
            type: 'success'
          });
          this.getCityList()
        }
      })
    },

    // 开启城市经理
    openCity(id) {
      this.$api.openUser(id, {
        userId: id
      }).then(res => {
        this.$message({
          message: '开启成功',
          type: 'success'
        });
        if(res.code === 200) {
          this.getCityList()
        }
      })
    }

  },
  created(){},
  mounted(){
    let self = this;
    self.getCityList()
  }
}
</script>
<style lang="less" scoped>
</style>